import React, { useEffect, createContext, useReducer } from "react";
import { UserReducers } from '../reducers/UserReducers'
import { UserTypes } from "../types/UserTypes"

export const UserContext = createContext()

export function UserProvider(props) {
    // console.log("PROPS -> ", props)
    console.log("localStorage.getItem('pm-session') -> ",localStorage.getItem('pm-session'))
    const decifrado = atob(localStorage.getItem('pm-session') || '')
    console.log("decifrado -> ", decifrado)
    const datosSession = decifrado == '' ? {} : JSON.parse(decifrado);
    console.log("datosSession -> ", datosSession)
    console.log('-> ',datosSession.codUsuarioTipo)

    const initialUserState = {
        codUsuario: datosSession.codUsuario || 0,
        codEmpresa: datosSession.codEmpresa || 0,
        nomUsuario: datosSession.nomUsuario || '',
        token: datosSession.token || '',
        tokenExpire: datosSession.tokenExpire || 0,
        menus: datosSession.menus || [],
        permisos: datosSession.permisos || [],
        codUsuarioTipo: datosSession.codUsuarioTipo || 0,
        nomFoto: datosSession.nomFoto || '',
        codAreaActual : datosSession.codAreaActual || 0,
        nomArea: datosSession.nomArea ||''
    }

    const [ state, dispatch ] = useReducer(UserReducers, initialUserState)

    const signIn = (objSession) => {
        console.log("DATOS INICIO SESION -> " ,objSession )
        var objetoSesion = objSession
        var cifrado = btoa(JSON.stringify(objetoSesion));
        localStorage.setItem('pm-session', cifrado);

        dispatch({type: UserTypes.SIGN_IN, payload: objetoSesion})
    }

    const signOut = () => {
        localStorage.clear();
        dispatch({type: UserTypes.SIGN_OUT})
    }

    const cambiarModulo = (nuevoModulo) => {
        // console.log("ENTRO AL CAMBIARMODULO ->", nuevoModulo)

        dispatch({type: UserTypes.CAMBIAR_MODULO, payload: {modulo:  nuevoModulo || 'tgac'}})
    
    }

    return (
        <UserContext.Provider value={{stateUser: state, signIn, signOut,cambiarModulo}}>
            {props.children}
        </UserContext.Provider>
    )
}